import React from "react"
import types from "prop-types"
import { workflowConditionShape } from "utils/propTypeShapes"
import { NumberInput } from "shared/inputs"
import FormsyValidation from "shared/FormsyValidation"

const DefineFlagCountValue = ({ condition, changeConditionValue, conditionIndex }) => {
  const updateValue = (val) => changeConditionValue({ flagCount: val })

  const currentValue = condition.value?.flagCount ?? ""

  return (
    <span className="relative">
      <div className="flex gap-2 items-center w-[100px]">
        <NumberInput
          className="bordered-base-input h-8"
          min={0}
          onChange={updateValue}
          value={currentValue}
          placeholder="0"
        />
        <FormsyValidation
          name={`conditions[${conditionIndex}].value.flagCountValue`}
          value={currentValue}
          validations={
            {
              isNumberGreaterThanOrEqualTo: { min: 0, errorMessage: "Can't be negative." },
              isNotBlankString: true,
            }
          }
          validationErrors={{ isDefaultRequiredValue: "required" }}
        />
      </div>
    </span>
  )
}

DefineFlagCountValue.propTypes = {
  condition: workflowConditionShape.isRequired,
  changeConditionValue: types.func.isRequired,
  conditionIndex: types.number.isRequired,
}

export default DefineFlagCountValue
